import * as yup from "yup";

export const signupSchema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup
    .string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  password: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  phone: yup.string().optional(),
  isVendor: yup.boolean().default(false),
  agreeToTerms: yup
    .boolean()
    .oneOf([true], "You must agree to the terms & policy")
    .required("You must agree to the terms & policy"),
});
